import styled, {css} from "styled-components"
import Card from "@irati/ui/src/experimental/Card"

interface WrapperProps {
  thumbnail: string
}
interface ImageProps {
  authorImage: string
}

export const Wrapper = styled(Card)<WrapperProps>`
  ${({thumbnail}) => css`
    position: relative;
    background-image: url("${thumbnail}");
    background-size: cover;
    overflow: hidden;
    width: 100%;
    padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
  `}
`

export const AuthorImage = styled.img<ImageProps>`
  ${({authorImage}) => css`
    position: absolute;
    background-image: url("${authorImage}");
    background-position: center;
    background-size: cover;
    width: 150px;
    height: 150px;
    top: 50%;
    bottom: 50%;
    transform: translateY(-50%);
    right: 45px;
    border-radius: 50%;
  `}
`
